// extracted by mini-css-extract-plugin
export default {"productListHeader":"productListHeader__1ImOt","categoriesBar":"categoriesBar__zUG2T"};
    if(module.hot) {
      // 1778491663475
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  